<div class="current-contract contract-properties">
  <div class="header-item">
    <div class="label">Contrato:</div>
    <div class="value" data-recording-sensitive>{{ currentContract }}</div>
  </div>
</div>
<div class="search" (clickOutside)="close()">
  <input
    type="text"
    required
    [(ngModel)]="contract"
    maxlength="12"
    (ngModelChange)="searchContract($event)"
    [class.filled]="isActive === true"
    title="Buscar número de contrato"
    class="search-input"
    (click)="$event.target.select()"
    (keydown)="navDown($event)"
    (focus)="setSearchResults(true)"
  />
  <label>Buscar contrato</label>
  <div
    class="reset-state icon-cancel"
    (click)="restoreSearch($event)"
    *ngIf="isActive"
  ></div>
</div>
<ul class="result-list" *ngIf="haveResults === true">
  <li class="option" *ngIf="contractsList.length < 1">
    <div class="item">No se encontraron resultados</div>
  </li>

  <ng-container *ngFor="let item of contractsList">
    <li
      tabindex="0"
      (keyup)="navDown($event)"
      class="option"
      (click)="selectContract(item.response)"
      attr.data-contractid="{{ item.response }}"
    >
      <div class="item" data-recording-sensitive>
        <span>{{ item.response }}</span>
      </div>
    </li>
  </ng-container>
</ul>
